<template>
<div>
  <h2 class="container-heading">
    <div> {{uwName}} </div>
  </h2>
</div>
</template>

<script setup>
import { computed } from 'vue';
import { useCorporateBranding } from '@/composables';

// Define component options
defineOptions({
  name: 'cc-underwriter-layout'
});

// Composables
const { getAllBrandingLogos } = useCorporateBranding();

// Computed properties
const uwName = computed(() => {
  const logos = getAllBrandingLogos.value;
  
  if (logos && logos.length > 0) {
    return logos[0].Name;
  } else {
    return "";
  }
});
</script>
<style scoped lang="stylus">
.container-heading {
  padding: 0 !important;
  color: #43425D;    
  font-size: 26px;
  font-family: 'Lato Bold', sans-serif;
}
</style>